*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: inline-block;
}

.wui-button-group-inner {
  display: flex;
  flex-direction: var(--wui-button-group-flex-direction, row);
  gap: 4px;
  align-items: center;

  width: max-content;
  height: 40px;
  padding: 0 4px;
  border-radius: calc(infinity * 1px);
}

:host([direction='vertical']) {
  --wui-button-group-flex-direction: column;
}

:host([direction='vertical']) .wui-button-group-inner {
  width: 40px;
  height: auto;
  padding: 4px 0;
}
